<a routerLink="/home"
   class="link-button"> <i class="fal fa-chevron-left"></i> Back </a>

<h1>Create Lumia Meeting</h1>

<div class="container">
    <label>Team</label>
    <select [ngModel]="teamId"
            (ngModelChange)="teamId = $event; updateTemplatesDisplay()"
            [disabled]="fetching"
            data-test="team-selector">
        @for (team of teams; track team) {
            <option [ngValue]="team.TeamId">{{ team.Name }}</option>
        }
    </select>

    <label>Meeting template</label>
    <select [(ngModel)]="meetingAgendaTemplateId"
            [disabled]="fetching"
            data-test="meeting-agenda-template-selector">
        @for (teams of meetingAgendaTemplates | keyvalue: originalMapOrderFn; track teams) {
            <optgroup label="{{ teams.key }}">
                @for (meetingAgendaTemplate of teams.value; track meetingAgendaTemplate) {
                    <option [ngValue]="meetingAgendaTemplate.MeetingAgendaTemplateId">
                        {{ meetingAgendaTemplate.Name }}
                    </option>
                }
            </optgroup>
        }

        <option [value]="undefined">-- None --</option>
    </select>

    <button (click)="createMeeting()"
            [adaptLoading]="sending"
            [adaptLoadingDisabled]="sending || fetching || !teamId"
            data-test="create-meeting-button"><i class="fal fa-plus-circle"></i> Create meeting in Lumia</button>
</div>

@if (fetching) {
    <p [adaptLoading]="fetching">Loading...</p>
}

<adapt-message-box [status]="status"
                   [message]="message"></adapt-message-box>
